import {Component} from '../component.interface';
import {FocusBoxDomInjector} from './focus-box-dom-injector';
import {FocusBoxConfig} from './focus-box-config.interface';

export class FocusBox implements Component {
    bootstrapped = false;
    focusBoxDomInjector: FocusBoxDomInjector;
    focusBoxContainerState = false;

    constructor(
        private window: Window,
        private document: Document,
        public config: FocusBoxConfig
    ) {
    }

    init(): void {
    }

    injectDom(hostElement?: HTMLDivElement): void {
        this.focusBoxDomInjector = new FocusBoxDomInjector(this.document, this.window, hostElement, this);
    }

    close(): void {
        this.focusBoxDomInjector.close();
    }

    open(): void {
        this.focusBoxContainerState = true;
        this.focusBoxDomInjector.open();
        this.config.toggleDisplay(true);
    }

    unOpen(): void {
        this.focusBoxContainerState = false;
        this.config.toggleDisplay(false);
        this.config.reset();
    }

    toggle(): void {
        if (this.focusBoxContainerState) {
            this.close();
            return;
        }
        this.open();
    }
}